import {
  RevenueStructureDoc,
  RevenueStructureWhole,
} from 'lib/interfaces/database/revenue-structure';
import _ from 'lodash';
import { RevenueStructuresService } from 'services/revenue-structures';
import { create } from 'zustand';

interface Filters {
  effective: Date;
  securityID: string;
}

interface State {
  data: RevenueStructureWhole[];
  filters: Partial<Filters>;
}

interface Actions {
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<RevenueStructureDoc>) => Promise<boolean>;
  readonly update: (
    id: string,
    v: Partial<RevenueStructureDoc>
  ) => Promise<boolean>;

  readonly setFilters: (v?: Partial<Filters>) => void;
}

interface Store extends State, Actions {}

const useRevStructStore = create<Store>((set, get) => {
  const service = RevenueStructuresService.getInstance();

  return {
    data: [],

    filters: {},

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.search({});

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      const record = await service.create(v);

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },

    setFilters: (v) => {
      if (!v) {
        // reset it entirely
        set({ filters: {} });
        return;
      }

      // merge the key(s) that changed
      const current = get().filters;
      set({ filters: { ...current, ...v } });
    },
  };
});

export default useRevStructStore;
